// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

import * as model from "@/model/em/admin/ImfMstShiftTimeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfMstShiftTime(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .buildStore()
